// extracted by extract-css-chunks-webpack-plugin
module.exports = {"hoverLine":"app-components-kit-waveform-hoverline--hoverLine","hoverTime":"app-components-kit-waveform-hoverline--hoverTime"};